import type { ReactNode } from 'react';

interface EntityRowActionsProps {
  children: ReactNode;
}

export function EntityRowActions({ children }: EntityRowActionsProps) {
  return (
    <div
      className="shrink-0 -mr-1 flex items-center gap-0.5"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
}
